<template>
  <IframeCmp type="120" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 跨境客户收入明细
  name: 'CrossBorderCustomerIncomeDetailStatement',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>

